module.exports = __webpack_public_path__ + "static/promotional-f931bf6fa8eaa3bfd9bfac0bceab7bdb.png";